// extracted by mini-css-extract-plugin
export default {"wrap":"rr-z","fullWidth":"sr-z","items":"tr-z","featureCss":"ur-z","disabled":"vr-z","imgCss":"wr-z"};